var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"boxEl",class:!!_vm.fill ? 'xq-svg-box' : 'non-fill',attrs:{"id":"svg-snap"}})}
var staticRenderFns = []

export { render, staticRenderFns }